import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { tap } from 'rxjs/operators';
import { Sat_Report } from '../sat/sat';


@Injectable({ providedIn: 'root' })
export class SatService
{

satUrl: string;
    constructor(private http: HttpClient) { 
         }

getSat_Reports()
{
    this.satUrl = environment.appURL+"/sat-reports";
     return this.http.get<Sat_Report[]>(this.satUrl,{headers: new HttpHeaders({"Authorization":"Bearer " + environment.token})})
     .pipe(
         tap(_ => {})
     );
   }

getSat_ReportByID(id : number)
{
    return this.http.get<Sat_Report>(environment.appURL + "/sat_reports/" + id, {headers :  new HttpHeaders ({"Authorization":"Bearer " + environment.token })});
}

}
